import {Column} from '@twpub/core/models';

export enum ClientProp {
  Locale = 'locale',
  TitleName = 'titleName',
  PoweredByType = 'poweredByType',
  PoweredByText = 'poweredByText',
  PoweredByLink = 'poweredByLink',
}

export enum PoweredByType {
  None = 'none',
  Text = 'text',
  Image = 'image'
}

export enum CompProp {
  Label = 'label',
  Visible = 'visible',
}

export enum ResultListProp {
  IncludeSynonyms = 'includeSynonyms',
  IncludeTranslations = 'includeTranslations',
  InitialSearch = 'initialSearch',
  IncludeTermLink = 'includeTermLink',
  IncludeResultLink = 'includeResultLink',
  ResultLinkLabel = 'resultLinkLabel',
  PageSize = 'pageSize',
  PageSizeOptions = 'pageSizeOptions',
  NeedSearchForEntry = 'needSearchForEntry',
  HasResultPage = 'hasResultPage',
  Columns = 'columns',
}

export type SearchResultConfig = {
  [ResultListProp.IncludeSynonyms]: boolean,
  [ResultListProp.InitialSearch]: boolean,
  [ResultListProp.Columns]: Column[];
};
